import { MClasification } from './clasification.model';
import { MNonConformityStatus } from './non-conformity-status.model';
import { MFase } from './fase.model';
import { MModuleDetail } from './module-detail.model';
import { MProcess } from './process.model';
import { MRequirement } from './requirement.model';
import { MTreatmentType } from './treatment-type.model';
import { MEvaluationCreator } from './evaluation-creator.model';
import { TracingInfo } from '../interfaces/treatment';
import { MResponsible } from './responsible.model';

export class MTracingItem{
    public id: number = null;
    public numero: number;
    public description: string = null;
    public requiresAnalisis: boolean = false;
    public clasification: MClasification = null;
    public status: MNonConformityStatus = null;
    public fase: MFase = null;
    public module: MModuleDetail = null;
    public process: MProcess = null;
    public requirement: MRequirement = null;
    public treatmentType:MTreatmentType;
    public approver: MEvaluationCreator = null;
    public creator: MEvaluationCreator = null;
    public owner: MEvaluationCreator = null;
    public title: string = null; 
    public createdAt: string = null; //@deprecated
    public createdAtDate:Date
    public closedAtDate:Date
    public closedAt: string = null; //@deprecated
    public responsibles: MResponsible[] = null;

    constructor(item: TracingInfo){
        this.id = item.id;
        this.numero = item.numero;
        this.title = item.titulo;
        this.description = item.descripcion;
        this.requiresAnalisis = item.requiere_analisis;
        this.clasification = item.clasificacion ? new MClasification(item.clasificacion) : null;
        this.status = item.estatus_nc ? new MNonConformityStatus(item.estatus_nc) : null;
        this.fase = item.fase ? new MFase(item.fase) : null;
        this.module = item.modulo ? new MModuleDetail(item.modulo) : null;
        this.process = item.proceso ? new MProcess(item.proceso) : null;
        this.requirement = item.requisito ? new MRequirement(item.requisito) : null;
        this.treatmentType = item.tipo_tratamiento ? new MTreatmentType(item.tipo_tratamiento) : null;
        this.approver = item.usuario_aprobador ? new MEvaluationCreator(item.usuario_aprobador) : null;
        this.creator = item.usuario_creador ? new MEvaluationCreator(item.usuario_creador) : null;
        this.owner = item.usuario_dueno ? new MEvaluationCreator(item.usuario_dueno) : null;
       
        this.createdAtDate = new Date(item.created_at);
        this.closedAtDate = new Date(item.fecha_cierre);
       
        if (item.created_at) {
            this.createdAt = item.created_at.substr(0 ,item.created_at.indexOf("T"));
        }
        if (item.fecha_cierre) {
            this.closedAt = item.fecha_cierre.substr(0, item.fecha_cierre.indexOf(" "))
        }
        if (item.fases_nc) {
            this.responsibles = [];
            item.fases_nc.forEach(item => {
                this.responsibles.push(new MResponsible(item));
            });
        }
    }
}